var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{class:['nav-alert', 'alert-'+_vm.blok.style],attrs:{"show":true,"fade":true,"dismissible":"","variant":"primary"}},[_vm._v(_vm._s(_vm.blok.label))])}
var staticRenderFns = []

export { render, staticRenderFns }